/**
 * Durable-ref validation, client half (docs/release-audit-checklist.md, rule 3).
 * Mirrors cloud/app/ops/refs.py: a ref persisted in a shared cloud record must be an
 * absolute http(s) URL EVERY device can fetch. Rejects file:// (local-hosting target),
 * blob:/data: (session-bound or multi-MB inline payloads), and root-relative paths
 * (they resolve against each device's own origin). The cloud now 422s non-durable
 * refs too — these client guards exist so failures surface at the flow the operator
 * is looking at, with a message that names the actual problem.
 */
export function isDurableRef(url: string | null | undefined): url is string {
  return typeof url === "string" && /^https?:\/\//i.test(url);
}

/** Human message for a non-durable hosting target, used by the upload panels. */
export function nonDurableRefMessage(what: string): string {
  return `${what} could not be published to hosting — other devices would not be able to load it. ` +
    "Check the hosting configuration (Settings → Hosting) and try again.";
}
